import React, { FC, useContext } from "react"
import Loader from "../../../components/Loader/Loader"
import { NoteContext } from "../../NotePage"
import { Alert, Tabs } from "antd"
import { HolderForm } from "./HolderForm"
import { HolderRequest } from "../../../client/backend-client/generated"
import { useSearchParams } from "react-router-dom"
import { orderBy } from "lodash"

export const HolderPageWrapper: FC = () => {
  const { areNoubaHoldersLoading, noubaHolders, areHoldersLoading, holders } =
    useContext(NoteContext)

  const [searchParams] = useSearchParams()

  if (areNoubaHoldersLoading || areHoldersLoading || !noubaHolders || !holders) {
    return <Loader />
  }

  return (
    <>
      {noubaHolders &&
        (noubaHolders.length > 0 ? (
          <Tabs
            items={orderBy(noubaHolders, ["lastName"], ["asc"]).map(noubaHolder => {
              const holder = holders.find(holder => holder.roleId === noubaHolder.id)
              return {
                label: `${noubaHolder.preferredName || noubaHolder.lastName || ""} ${noubaHolder.firstName || ""}`,
                key: noubaHolder.id ?? "",
                children: noubaHolder.id && (
                  <HolderForm
                    holderId={noubaHolder.id}
                    noubaHolder={noubaHolder}
                    holder={holder ?? ({} as HolderRequest)}
                  />
                )
              }
            })}
            defaultActiveKey={searchParams.get("holderId") ?? undefined}
          />
        ) : (
          <Alert message="Aucun porteur n'a été trouvé sur cette note." type="warning" />
        ))}
    </>
  )
}
